/**
 * Toolbar de captura mobile para Reunião Ao Vivo.
 * Visível apenas em mobile (md:hidden).
 * Botões: Foto (câmera), Rabisco (desenho).
 * Gravação de áudio é automática — sem botão manual.
 */
interface AoVivoMobileToolbarProps {
  onPhoto: () => void
  onDraw: () => void
}

export default function AoVivoMobileToolbar({ onPhoto, onDraw }: AoVivoMobileToolbarProps) {
  return (
    <div className="flex items-center justify-center gap-4 py-3 md:hidden">
      {/* Foto */}
      <button
        onClick={onPhoto}
        title="Tirar foto"
        className="w-10 h-10 rounded-full flex items-center justify-center bg-white/[0.04] hover:bg-white/[0.08] border border-white/[0.07] transition-colors cursor-pointer"
      >
        <span className="material-symbols-outlined text-[#555] text-xl">photo_camera</span>
      </button>

      {/* Rabisco */}
      <button
        onClick={onDraw}
        title="Rabiscar"
        className="w-10 h-10 rounded-full flex items-center justify-center bg-white/[0.04] hover:bg-white/[0.08] border border-white/[0.07] transition-colors cursor-pointer"
      >
        <span className="material-symbols-outlined text-[#555] text-xl">draw</span>
      </button>
    </div>
  )
}
